import { graphql } from "@/graphql/codegen"

graphql(`
  mutation CreatePayFile($input: CreatePayFileInput!) {
    payFile {
      create(input: $input) {
        __typename
        ... on CreatePayFileSuccess {
          payFile {
            payFileId
          }
        }
        ... on CreatePayFileFailure {
          error {
            message
          }
        }
      }
    }
  }
`)
